import { ReactNode } from 'react'

interface BaseMenuSection {
  sectionLabel: ReactNode | string
  path: string
  children?: MenuItemProps[]
  privileges?: string[]
}

export interface BaseMenuItem {
  label: ReactNode | string
  path?: string
  icon?: ReactNode | string
  privileges?: string[]
}
interface MenuItemWithoutChildren extends BaseMenuItem {
  children?: never
  name?: never
}
interface MenuItemWithChildren extends BaseMenuItem {
  children: MenuItemProps[]
  name: string
}

export type MenuSectionProps = BaseMenuSection & {
  label?: never
  icon?: never
}

export type MenuItemProps = (MenuItemWithoutChildren | MenuItemWithChildren) & {
  sectionLabel?: never
}

type RouterListItem = MenuSectionProps | MenuItemProps

type RouterList = Record<string, {
  rootPath: string
  items: RouterListItem[]
}>
export const routerList: RouterList = {
  console: {
    rootPath: '/console',
    items: [
      {
        label: 'dashboard',
        icon: 'lucide:layout-dashboard',
        path: '/dashboard',
        privileges: ['0.1'],
      },
      {
        sectionLabel: 'Configuration',
        path: '/',
        children: [
          {
            label: 'divisions',
            icon: 'ri:team-line',
            path: '/divisions/list',
            privileges: ['0.4.0'],
          },
          {
            label: 'roles',
            icon: 'oui:app-users-roles',
            path: '/roles/list',
            privileges: ['0.3.5'],
          },
          {
            label: 'operators groups',
            icon: 'gis:globe-users',
            path: '/operator-groups/list',
            privileges: ['0.3.3'],

          },
        ],
      },
      {
        sectionLabel: 'management',
        path: '/',
        children: [
          {
            label: 'distributor',
            icon: 'lucide:file-key-2',
            path: '/distributor/list',
            privileges: ['0.3.7'],
          },
          {
            label: 'integrator',
            icon: 'mdi:worker-outline',
            path: '/integrator/list',
            privileges: ['0.3.0'],
          },
          {
            name: 'Products',
            label: 'products',
            icon: 'lucide:folder-kanban',
            path: '/products',
            children: [
              {
                label: 'Templates',
                icon: 'lucide:book',
                path: '/templates/list',
                privileges: ['0.3.8.16'],

              },
              {
                label: 'Features',
                icon: 'lucide:proportions',
                path: '/features/list',
                privileges: ['0.3.8.4'],
              },
              {
                label: 'Privileges',
                icon: 'lucide:key',
                path: '/privileges/list',
                privileges: ['0.3.8.8'],
              },
            ],
          },
          {
            name: 'Sites',
            label: 'sites',
            icon: 'lucide:building-2',
            path: '/sites',
            children: [
              {
                label: 'list',
                icon: 'lucide:table',
                path: '/list',
                privileges: ['0.3.1'],

              },
              {
                label: 'licenses',
                icon: 'lucide:newspaper',
                path: '/licenses/list',
                privileges: ['0.3.1.5'],
              },
            ],
          },
          {
            label: 'QR',
            icon: 'lucide:qr-code',
            path: '/qr/list',
            privileges: ['0.3.1.11'],
          },
        ],
      },
    ],
  },
}
